import { render, staticRenderFns } from "./SettingsPopup.vue?vue&type=template&id=0949b21b&"
import script from "./SettingsPopup.vue?vue&type=script&lang=js&"
export * from "./SettingsPopup.vue?vue&type=script&lang=js&"
import style0 from "./SettingsPopup.vue?vue&type=style&index=0&id=0949b21b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports